import {EditableUserAttributes} from '../models/editableUserAttributes.model';

export class User {
  id?: number;
  sapSalesOrganization?: string;
  sapCompanyCode?: string;
  sapPlant?: string;
  sapUserName?: string;
  customerId?: number;
  customerNumber?: string;
  customerName?: string;
  customerCategory?: any;
  crmContactId?: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  birthDate?: any;
  phone?: string;
  language?: string;
  countryCode?: string;
  postalCode?: string;
  roles?: Array<any>;
  active?: boolean;
  confirmed?: boolean;
  avatar?: any;
  customerAdmin?: boolean;
  wantsNewsletter?: boolean;
  ldapUser?: boolean;
  targetGroup?: string;
  emailVerified?: boolean;
  editableAttributes?: EditableUserAttributes;
}
